<div class="lessons-list-container">
  <ng-template [ngTemplateOutlet]="_listTemplate"></ng-template>
  <!--ng-template [ngTemplateOutlet]="isSwipeList ? _swipeListTemplate : _listTemplate"></ng-template-->
  <div class="lessons-list-spacer"></div>
</div>

<ng-template #_customTemplateSrc let-item="item" let-id="id" let-index="$index" let-isFirst="isFirst" let-isLast="isLast">
  <pop-ui-lesson-tile-study
    [tile]="tileFor(item.id)"
    [(state)]="state"
    [rootClassName]="rootClassName"
  ></pop-ui-lesson-tile-study>
</ng-template>

<!-- a plain list  -->

<ng-template #_listTemplate>
  @defer (when isLoaded) {
    @for (tile of tileSource; track $index; let isFirst = $first; let isLast = $last) {
      @if(isFirst) {
        <div
        tourAnchor="{{isOnboarding ? undefined : 'anchor.lessons-list.1'}}"
        class="lessons-list-content"
        [ngClass]="{ selected: isSelected(tile) }"
        >
        <ng-template
          [ngTemplateOutlet]="_customTemplateSrc"
          [ngTemplateOutletContext]="{ item: inside(tile), id: tile.id, $index, isFirst, isLast }"
        ></ng-template>
        </div>
      } @else {
        <div
        class="lessons-list-content"
        [ngClass]="{ selected: isSelected(tile) }"
        >
        <ng-template
          [ngTemplateOutlet]="_customTemplateSrc"
          [ngTemplateOutletContext]="{ item: inside(tile), id: tile.id, $index, isFirst, isLast }"
        ></ng-template>
        </div>
      }
    }
  }
</ng-template>


<!-- a swipe to delete list -->

<ng-template #_swipeListTemplate>
  @for (tile of tileSource; track $index; let isLast = $last) {
    <nx-superprep-swipe-item-list
      class="lessons-list-content"
      [ngClass]="{ selected: isSelected(tile) }"
      [inside]="inside(tile)"
      [itemClass]="'lessons-list-item'"
      [showMark]="false"
      [disabledMark]="false"
      (swClick)="onSelect(tile)"
      [delTemplate]="_delTemplate"
      [customTemplate]="_customTemplateSrc"
      (callback)="onAction($event)"
      (swipeCb)="onSwipe($event)"
    >
    </nx-superprep-swipe-item-list>
  }
</ng-template>

<ng-template #_delTemplate>
  <mat-icon aria-hidden="false" aria-label="delete" fontIcon="trash"></mat-icon>
</ng-template>

<!-- a material swipe to delete list -->

<ng-template #_identityTemplate let-item>
  <img loading="lazy" src="{{ item.imageUrl }}" />
</ng-template>
